<template>
  <div class="sign-up-success">
    <SignInUpCommon>
      <template v-slot:mainHeaderTitle>
        Welcome to Tech Master Event Community!
      </template>
      <template v-slot:mainHeaderSubtitle>
        Finish final steps to make your account active.
      </template>
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" class="text-center">
            <div class="secondary rounded-circle step-number">1</div>
            <v-icon size="72" color="primary" class="mb-3"
              >mdi-email-alert</v-icon
            >
            <h2>Check your e-mail inbox</h2>
          </v-col>
          <v-col cols="12" sm="4" class="text-center">
            <div class="secondary rounded-circle step-number">2</div>
            <v-icon size="72" color="primary" class="mb-3"
              >mdi-link-lock</v-icon
            >
            <h2 class="text-center">Click on the activation link</h2>
          </v-col>
          <v-col cols="12" sm="4" class="text-center">
            <div class="secondary rounded-circle step-number">3</div>
            <v-icon size="72" color="primary" class="mb-3"
              >mdi-account-circle</v-icon
            >
            <h2 class="text-center">Sign in Tech Master Event</h2>
          </v-col>
        </v-row>
      </v-container>
    </SignInUpCommon>
  </div>
</template>

<script>
import SignInUpCommon from '@/components/user/SignInUpCommon.vue'

export default {
  name: 'Sign-up-success',
  components: {
    SignInUpCommon,
  },
  data: () => ({}),
}
</script>
<style>
.step-number {
  padding: 3px;
  width: 30px;
  color: #fff;
}
</style>
